import { createReducer } from '@reduxjs/toolkit';
import {
    getReturnReasonStart,
    getReturnReasonSuccess,
    getReturnReasonFailure,
    
    getStoreAddressesStart,
    getStoreAddressesSuccess,
    getStoreAddressesFailure,

    createReturnOrderStart,
    createReturnOrderSuccess,
    createReturnOrderFailure,

    getReturnOrdersStart,
    getReturnOrdersSuccess,
    getReturnOrdersFailure,

} from './orderReturnActions'; // Adjust the import path as needed



const initialState = {
    loading: false,
    returnReasons: [],
    storeAddresses: [],
    returnOrders: [],
    errorMessage: null,
    successMessage: null,
};

const orderReturnReducer = createReducer(initialState, (builder) => {
    builder
        // Get Return Reason
        .addCase(getReturnReasonStart, (state) => {
            state.loading = true;
            state.errorMessage = null;
        })
        .addCase(getReturnReasonSuccess, (state, action) => {
            state.loading = false;
            state.returnReasons = action.payload.data;
        })
        .addCase(getReturnReasonFailure, (state, action) => {
            state.loading = false;
            state.returnReasons = [];
            state.errorMessage = action.payload.message;
        })

        // Get Store Addresses
        .addCase(getStoreAddressesStart, (state) => {
            state.loading = true;
            state.errorMessage = null;
        })
        .addCase(getStoreAddressesSuccess, (state, action) => {
            state.loading = false;
            state.storeAddresses = action.payload.data;
        })
        .addCase(getStoreAddressesFailure, (state, action) => {
            state.loading = false;
            state.storeAddresses = [];
            state.errorMessage = action.payload.message;
        })

        // Create Return Order
        .addCase(createReturnOrderStart, (state) => {
            state.loading = true;
            state.successMessage = null;
            state.errorMessage = null;
        })
        .addCase(createReturnOrderSuccess, (state, action) => {
            state.loading = false;
            state.returnDetails = action.payload.data;
            state.successMessage = action.payload.message;
        })
        .addCase(createReturnOrderFailure, (state, action) => {
            state.loading = false;
            state.returnDetails = null;
            state.errorMessage = action.payload.message;
        })

        .addCase(getReturnOrdersStart, (state) => {
            state.loading = true;
            state.errorMessage = null;
        })
        .addCase(getReturnOrdersSuccess, (state, action) => {
            state.loading = false;
            state.returnOrders = action.payload.data;
        })
        .addCase(getReturnOrdersFailure, (state, action) => {
            state.loading = false;
            state.returnOrders = [];
            state.errorMessage = action.payload.message;
        });

});

export default orderReturnReducer;
